// search redirects variable
var searchRedirects = {
  "Collection Pages": [
    {
      Keyword: "longsleeve",
      Redirect: "https://teveo.com/collections/longsleeve-damen",
    },
    {
      Keyword: "longsleeves",
      Redirect: "https://teveo.com/collections/longsleeve-damen",
    },
    null,
    {
      Keyword: "hoodie",
      Redirect: "https://teveo.com/collections/pullover",
    },
    {
      Keyword: "hoodies",
      Redirect: "https://teveo.com/collections/pullover",
    },
    {
      Keyword: "sweater",
      Redirect: "https://teveo.com/collections/pullover",
    },
    {
      Keyword: "sweatjacke",
      Redirect: "https://teveo.com/collections/pullover",
    },
    {
      Keyword: "sweatjacken",
      Redirect: "https://teveo.com/collections/pullover",
    },
    null,
    {
      Keyword: "zubehör",
      Redirect: "https://teveo.com/collections/zubehoer",
    },
    {
      Keyword: "sport zubehör",
      Redirect: "https://teveo.com/collections/zubehoer",
    },
    null,
    {
      Keyword: "leggings",
      Redirect: "https://teveo.com/collections/hosen-leggings",
    },
    {
      Keyword: "leggins",
      Redirect: "https://teveo.com/collections/hosen-leggings",
    },
    {
      Keyword: "jogginghose",
      Redirect: "https://teveo.com/collections/hosen-leggings",
    },
    null,
    {
      Keyword: "short",
      Redirect: "https://teveo.com/collections/shorts",
    },
    {
      Keyword: "shorts",
      Redirect: "https://teveo.com/collections/shorts",
    },
    null,
    {
      Keyword: "socken",
      Redirect: "https://teveo.com/collections/sport-unterwaesche",
    },
    {
      Keyword: "unterwäsche",
      Redirect: "https://teveo.com/collections/sport-unterwaesche",
    },
    null,
    {
      Keyword: "sport bh",
      Redirect: "https://teveo.com/collections/sport-bh",
    },
    null,
    {
      Keyword: "tanga",
      Redirect: "https://teveo.com/collections/sport-tanga",
    },
  ],
  Collections: [
    {
      Keyword: "charming",
      Redirect: "https://teveo.com/collections/charming",
    },
    {
      Keyword: "camo",
      Redirect: "https://teveo.com/collections/camo",
    },
    {
      Keyword: "classic",
      Redirect: "https://teveo.com/collections/classic",
    },
    {
      Keyword: "classy",
      Redirect: "https://teveo.com/collections/classy",
    },
    {
      Keyword: "college",
      Redirect: "https://teveo.com/collections/college",
    },
    {
      Keyword: "comfy",
      Redirect: "https://teveo.com/collections/comfy",
    },
    {
      Keyword: "elegant",
      Redirect: "https://teveo.com/collections/elegant",
    },
    {
      Keyword: "everyday",
      Redirect: "https://teveo.com/collections/everyday",
    },
    {
      Keyword: "evolution",
      Redirect: "https://teveo.com/collections/evolution",
    },
    {
      Keyword: "focus",
      Redirect: "https://teveo.com/collections/focus",
    },
    {
      Keyword: "ionic",
      Redirect: "https://teveo.com/collections/ionic",
    },
    {
      Keyword: "lounge",
      Redirect: "https://teveo.com/collections/lounge",
    },
    {
      Keyword: "power",
      Redirect: "https://teveo.com/collections/power",
    },
    {
      Keyword: "ribbed",
      Redirect: "https://teveo.com/collections/ribbed",
    },
    {
      Keyword: "sassy",
      Redirect: "https://teveo.com/collections/sassy",
    },
    {
      Keyword: "sensation",
      Redirect: "https://teveo.com/collections/sensation",
    },
    {
      Keyword: "statement",
      Redirect: "https://teveo.com/collections/statement",
    },
    {
      Keyword: "timeless",
      Redirect: "https://teveo.com/collections/timeless",
    },
    {
      Keyword: "true ",
      Redirect: "https://teveo.com/collections/true",
    },
    {
      Keyword: "v shape",
      Redirect: "https://teveo.com/collections/v-shape",
    },
    {
      Keyword: "v-shape",
      Redirect: "https://teveo.com/collections/v-shape",
    },
    {
      Keyword: "vshape",
      Redirect: "https://teveo.com/collections/v-shape",
    },
  ],
  Content: [
    {
      Keyword: "sale",
      Redirect: "https://teveo.com/collections/last-chance",
    },
    null,
    {
      Keyword: "zoll",
      Redirect: "https://teveo.com/pages/zoll-und-einfuhrgebuhren",
    },
    {
      Keyword: "zollgebühren",
      Redirect: "https://teveo.com/pages/zoll-und-einfuhrgebuhren",
    },
    null,
    {
      Keyword: "kontakt",
      Redirect: "https://teveo.com/pages/kontakt",
    },
    {
      Keyword: "kontaktformular",
      Redirect: "https://teveo.com/pages/kontakt",
    },
    {
      Keyword: "kontaktfoemular",
      Redirect: "https://teveo.com/pages/kontakt",
    },
    {
      Keyword: "telefon kontakt",
      Redirect: "https://teveo.com/pages/kontakt",
    },
    {
      Keyword: "telefonischer kontakt",
      Redirect: "https://teveo.com/pages/kontakt",
    },
    {
      Keyword: "telefonkontakt",
      Redirect: "https://teveo.com/pages/kontakt",
    },
    {
      Keyword: "teveo kundenkontakt",
      Redirect: "https://teveo.com/pages/kontakt",
    },
    null,
    {
      Keyword: "agb",
      Redirect: "https://teveo.com/policies/terms-of-service",
    },
    null,
    {
      Keyword: "impressum",
      Redirect: "https://teveo.com/policies/legal-notice",
    },
    null,
    {
      Keyword: "hilfe",
      Redirect: "https://teveo.com/a/help",
    },
    {
      Keyword: "support",
      Redirect: "https://teveo.com/a/help",
    },
    null,
    {
      Keyword: "karriere",
      Redirect: "https://teveo.recruitee.com/",
    },
    null,
    {
      Keyword: "über uns",
      Redirect: "https://teveo.com/pages/relaunch-about-us",
    },
  ],
  Return: [
    {
      Keyword: "retoure",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "retouren",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "retourenportal",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "retourenschein",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "retoure paypal",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "retourenetikett",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "retourenlabel",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "retoureportal",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "retoure anmelden",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "retoure stornieren",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "retourekosten",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "anweisungen in unserem retouren",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "dhl retoure",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "gratis retoure",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "gutschein retoure",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "retoure einzelteile",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "retoure kostenlos",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "retoure label",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "retoure schein",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "retouree",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "retourelabel",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "retourenettikett",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "retourenportqal",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "retourenportsl",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "retourenprtal",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "retoureschein",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "retouretikett",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "teveo retoure",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "teveo v retoure",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "versand und retoure",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "rückversand",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "ruckversand",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "rückversandt",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "rüchversand",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "rück versand",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "rückversandkosten",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "rückversands",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "rüvkversand",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
    {
      Keyword: "versand rücksendung",
      Redirect: "https://teveo.com/pages/rucksendung-ruckerstattung",
    },
  ],
  Shipping: [
    {
      Keyword: "versand",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "versandkosten",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "versandt",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "versandkostenfrei",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "keine versandbestätigung",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "kostenloser versand",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "sparschwein versand de",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "versand kosten",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "versandkosten frei",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "versandstatus",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "expressversand",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "gratis versand",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "letzer versand",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "mein versand",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "meinen versandverlauf",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "teveo versandkosten",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "versand koste",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "versand lieferung",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "versand und retoure",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "versand zeit",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "versandbestätigung",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "versanddauer",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "versandgebühren",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "versandkoatenfrei",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "versandkosrten",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "versandkoste",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "versandkosten trotz 100",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "versandkostwn",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "versandservice",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "versandtkosten",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "versandzeit",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "was kostet der versand",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "welcher versandservice",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "wie lange dauert der versand von gutscheinen",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
    {
      Keyword: "wie viel kostet der versand",
      Redirect: "https://teveo.com/pages/versand-versandkosten",
    },
  ],
  Ambassador: [
    {
      Keyword: "amelie",
      Redirect: "https://teveo.com/pages/amelie",
    },
    {
      Keyword: "amelie pink",
      Redirect: "https://teveo.com/pages/amelie",
    },
    {
      Keyword: "amelies favorieten",
      Redirect: "https://teveo.com/pages/amelie",
    },
    null,
    null,
    {
      Keyword: "anna",
      Redirect: "https://teveo.com/pages/anna",
    },
    {
      Keyword: "anna klinski",
      Redirect: "https://teveo.com/pages/anna",
    },
    {
      Keyword: "anna von klinski",
      Redirect: "https://teveo.com/pages/anna",
    },
    {
      Keyword: "anna von",
      Redirect: "https://teveo.com/pages/anna",
    },
    {
      Keyword: "annavonklinski",
      Redirect: "https://teveo.com/pages/anna",
    },
    {
      Keyword: "teveo x anna",
      Redirect: "https://teveo.com/pages/anna",
    },
    {
      Keyword: "annaklinski",
      Redirect: "https://teveo.com/pages/anna",
    },
    {
      Keyword: "anna kollektion",
      Redirect: "https://teveo.com/pages/anna",
    },
    {
      Keyword: "teveo x anna von klinski",
      Redirect: "https://teveo.com/pages/anna",
    },
    {
      Keyword: "anna klinkst",
      Redirect: "https://teveo.com/pages/anna",
    },
    {
      Keyword: "anna collection",
      Redirect: "https://teveo.com/pages/anna",
    },
    {
      Keyword: "anna kilinski",
      Redirect: "https://teveo.com/pages/anna",
    },
    {
      Keyword: "anna klinsky",
      Redirect: "https://teveo.com/pages/anna",
    },
    {
      Keyword: "x anna",
      Redirect: "https://teveo.com/pages/anna",
    },
    {
      Keyword: "anna kalinski",
      Redirect: "https://teveo.com/pages/anna",
    },
    {
      Keyword: "anna x teveo",
      Redirect: "https://teveo.com/pages/anna",
    },
    null,
    {
      Keyword: "Hannah",
      Redirect: "https://teveo.com/pages/hannah",
    },
    {
      Keyword: "carolina",
      Redirect: "https://teveo.com/pages/hannah",
    },
    null,
    {
      Keyword: "lara",
      Redirect: "https://teveo.com/pages/lara",
    },
    {
      Keyword: "lara emilia",
      Redirect: "https://teveo.com/pages/lara",
    },
    null,
    {
      Keyword: "cora",
      Redirect: "https://teveo.com/pages/cora",
    },
    {
      Keyword: "cora nie",
      Redirect: "https://teveo.com/pages/cora",
    },
  ],
  "Newsletter & Discounts": [
    {
      Keyword: "rabatt",
      Redirect: "https://teveo.com/pages/newsletter-rabatt",
    },
    {
      Keyword: "rabatte",
      Redirect: "https://teveo.com/pages/newsletter-rabatt",
    },
    {
      Keyword: "rabattcode",
      Redirect: "https://teveo.com/pages/newsletter-rabatt",
    },
    {
      Keyword: "rabattcodes",
      Redirect: "https://teveo.com/pages/newsletter-rabatt",
    },
    {
      Keyword: "rabatt code",
      Redirect: "https://teveo.com/pages/newsletter-rabatt",
    },
    {
      Keyword: "studenten rabatt",
      Redirect: "https://teveo.com/pages/newsletter-rabatt",
    },
    {
      Keyword: "neukundenrabatt",
      Redirect: "https://teveo.com/pages/newsletter-rabatt",
    },
    {
      Keyword: "neukunde rabatt",
      Redirect: "https://teveo.com/pages/newsletter-rabatt",
    },
    {
      Keyword: "anmelderabatt",
      Redirect: "https://teveo.com/pages/newsletter-rabatt",
    },
    null,
    {
      Keyword: "newsletter",
      Redirect: "https://teveo.com/pages/newsletter-rabatt",
    },
    {
      Keyword: "10 newsletter",
      Redirect: "https://teveo.com/pages/newsletter-rabatt",
    },
    {
      Keyword: "newsletter anmelden",
      Redirect: "https://teveo.com/pages/newsletter-rabatt",
    },
    {
      Keyword: "newsletters",
      Redirect: "https://teveo.com/pages/newsletter-rabatt",
    },
    {
      Keyword: "anmeldung newsletter",
      Redirect: "https://teveo.com/pages/newsletter-rabatt",
    },
    {
      Keyword: "10 prozent newsletter",
      Redirect: "https://teveo.com/pages/newsletter-rabatt",
    },
    {
      Keyword: "newsletter 10",
      Redirect: "https://teveo.com/pages/newsletter-rabatt",
    },
    {
      Keyword: "newsletter abonnieren",
      Redirect: "https://teveo.com/pages/newsletter-rabatt",
    },
    {
      Keyword: "newsletter anmeldung",
      Redirect: "https://teveo.com/pages/newsletter-rabatt",
    },
    {
      Keyword: "newsletter anmeldung rabatt",
      Redirect: "https://teveo.com/pages/newsletter-rabatt",
    },
    {
      Keyword: "newsletter rabatt",
      Redirect: "https://teveo.com/pages/newsletter-rabatt",
    },
    {
      Keyword: "newsletterrabatt",
      Redirect: "https://teveo.com/pages/newsletter-rabatt",
    },
  ],
};
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  if (elementToFocus) elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => {
    video.pause();
    if (
      video.parentNode &&
      video.parentNode.classList.contains("deferred-media__poster--videos")
    ) {
      video.play();
    }
  });
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class ToastNotification extends HTMLElement {
  constructor() {
    super();
    this.messageElement = this.querySelector(".toast_notification_message");
    this.dismissButton = this.querySelector(".toast_dismiss_button");
    this.progressBar = this.querySelector(".toast_notification_progress_bar");
    this.imageElement = this.querySelector(".toast_notification_image");
    this.duration = 5000; // 5 seconds
    this.isVisible = false;
    this.animationFrame = null;
    this.startTime = 0;
    this.anchorSelector = null;
    this.actionUrl = null;
    this.reposition = this.reposition.bind(this);
    this.handleToastEvent = this.handleToastEvent.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);

    this.setupEventListeners();
  }

  connectedCallback() {
    // Listen for custom toast events from anywhere in the app
    document.addEventListener('show-toast', this.handleToastEvent);
    window.addEventListener('resize', this.reposition);
    window.addEventListener('scroll', this.reposition, {passive: true});
  }

  disconnectedCallback() {
    document.removeEventListener('show-toast', this.handleToastEvent);
    window.removeEventListener('resize', this.reposition);
    window.removeEventListener('scroll', this.reposition);
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
    }
  }

  setupEventListeners() {
    // Handle dismiss button click
    if (this.dismissButton) {
      this.dismissButton.addEventListener('click', (event) => {
        event.stopPropagation();
        this.hide();
      });
    }

    this.addEventListener('click', this.handleClick);
    this.addEventListener('keydown', this.handleKeydown);
  }

  handleToastEvent(event) {
    const { message, duration = 5000, imageUrl, imageAlt = '', variant = '', anchorSelector = null, actionUrl = null } = event.detail || {};
    if (message) {
      this.show(message, duration, {imageUrl, imageAlt, variant, anchorSelector, actionUrl});
    }
  }

  handleClick(event) {
    if (!this.actionUrl || event.target.closest('.toast_dismiss_button')) {
      return;
    }

    window.location.href = this.actionUrl;
  }

  handleKeydown(event) {
    if (!this.actionUrl || event.target.closest('.toast_dismiss_button') || !['Enter', ' '].includes(event.key)) {
      return;
    }

    event.preventDefault();
    window.location.href = this.actionUrl;
  }

  show(message, duration = this.duration, options = {}) {
    // Update message content
    if (this.messageElement) {
      this.messageElement.textContent = message;
    }

    this.classList.toggle('toast_notification--wishlist', options.variant === 'wishlist');
    this.anchorSelector = options.anchorSelector || null;
    this.actionUrl = options.actionUrl || null;
    this.classList.toggle('toast_notification--clickable', Boolean(this.actionUrl));
    if (this.actionUrl) {
      this.setAttribute('role', 'link');
      this.setAttribute('tabindex', '0');
    } else {
      this.removeAttribute('role');
      this.removeAttribute('tabindex');
    }

    if (this.imageElement) {
      if (options.imageUrl) {
        this.imageElement.src = options.imageUrl;
        this.imageElement.alt = options.imageAlt || '';
        this.imageElement.hidden = false;
      } else {
        this.imageElement.removeAttribute('src');
        this.imageElement.alt = '';
        this.imageElement.hidden = true;
      }
    }

    // Show the toast with slide-in animation
    this.style.display = options.variant === 'wishlist' ? 'flex' : 'block';
    this.reposition();
    this.classList.add('active');
    this.isVisible = true;
    this.duration = duration;

    // Start progress bar animation
    this.startProgressBar();
  }

  hide() {
    this.classList.remove('active');
    this.isVisible = false;
    this.anchorSelector = null;
    this.actionUrl = null;
    this.classList.remove('toast_notification--clickable');
    this.removeAttribute('role');
    this.removeAttribute('tabindex');

    // Hide after animation completes
    setTimeout(() => {
      this.style.display = 'none';
      this.style.removeProperty('--toast-top');
      this.style.removeProperty('--toast-right');
      this.style.removeProperty('top');
      this.style.removeProperty('right');
      this.resetProgressBar();
    }, 300); // Match CSS transition duration

    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
    }
  }

  startProgressBar() {
    this.startTime = performance.now();
    this.updateProgressBar();
  }

  updateProgressBar() {
    if (!this.isVisible) return;

    const elapsed = performance.now() - this.startTime;
    const progress = Math.min((elapsed / this.duration) * 100, 100);

    if (this.progressBar) {
      this.progressBar.style.width = `${progress}%`;
    }

    if (progress < 100) {
      this.animationFrame = requestAnimationFrame(() => this.updateProgressBar());
    } else {
      // Auto-hide when progress reaches 100%
      this.hide();
    }
  }

  resetProgressBar() {
    if (this.progressBar) {
      this.progressBar.style.width = '0%';
    }
  }

  reposition() {
    if (!this.anchorSelector) {
      this.style.removeProperty('--toast-top');
      this.style.removeProperty('--toast-right');
      this.style.removeProperty('top');
      this.style.removeProperty('right');
      return;
    }

    const anchor = document.querySelector(this.anchorSelector);
    if (!anchor) {
      return;
    }

    const rect = anchor.getBoundingClientRect();
    const viewportGap = 36;
    const right = Math.max(16, window.innerWidth - rect.right - viewportGap);

    this.style.setProperty('--toast-top', `${Math.round(rect.bottom + 18)}px`);
    this.style.setProperty('--toast-right', `${Math.round(right)}px`);
    this.style.top = `${Math.round(rect.bottom + 18)}px`;
    this.style.right = `${Math.round(right)}px`;
  }
}

customElements.define("toast-notification", ToastNotification);

window.showToast = function (message, duration = 5000) {
  const detail = typeof message === 'object' && message !== null
    ? {...message, duration: message.duration || duration}
    : { message, duration };
  const event = new CustomEvent('show-toast', {
    detail
  });
  document.dispatchEvent(event);
};

class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.getElementById("shopify-section-new-header");
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector("predictive-search");

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
    window.addEventListener("scroll", this.onScrollHandler, false);

    this.createObserver();
    this.setHeaderHeight();

    this.resizeObserver = new ResizeObserver(() => this.setHeaderHeight());
    this.resizeObserver.observe(this);

    this.addEventListener("transitionend", () => this.setHeaderHeight());
  }

  disconnectedCallback() {
    this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
    window.removeEventListener("scroll", this.onScrollHandler);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  setHeaderHeight() {
    const height = Math.max(0, this.getBoundingClientRect().bottom);
    document.documentElement.style.setProperty(
      "--sticky-header-height",
      `${height}px`
    );
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (
      scrollTop > this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      // Scrolling down past threshold - add collapsed class
      this.classList.add("collapsed");
    } else if (scrollTop < this.currentScrollTop) {
      // Scrolling up - remove collapsed class
      this.classList.remove("collapsed");
    }

    if (scrollTop <= this.headerBounds.top) {
      // Back at top - ensure collapsed is removed
      this.classList.remove("collapsed");
    }

    this.currentScrollTop = scrollTop;
    this.setHeaderHeight();
  }
}

customElements.define("sticky-header", StickyHeader);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

// It will get the blocks and display the tabs on top and the content below it, depending on the tab selected, will have an active class on the open one.

// The selectors are, .action-tab-trigger, .tab-content and they will passed as children to this element. You should be able to pass the data-tab attribute to the trigger and the content will be displayed based on it.
class TabsMenu extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.createTabsHeader();
    this.querySelectorAll(".action-tab-trigger").forEach((trigger) => {
      trigger.addEventListener("click", this.onTabClick.bind(this));
    });

    // Set first tab as active by default
    const firstTab = this.querySelector(".action-tab-trigger");
    if (firstTab) {
      firstTab.classList.add("active");
      const firstContent = this.querySelector(
        `.tab-content[data-tab="${firstTab.dataset.tab}"]`
      );
      if (firstContent) {
        firstContent.classList.add("active");
      }
    }
  }

  createTabsHeader() {
    const tabTriggers = this.querySelectorAll(".action-tab-trigger");
    if (tabTriggers.length > 0) {
      const tabsHeader = document.createElement("div");
      tabsHeader.className = "tabs-menu-header";

      tabTriggers.forEach((trigger, index) => {
        const tabButton = document.createElement("div");
        tabButton.className = `tabs-menu-trigger ${index === 0 ? "active" : ""}`;
        tabButton.dataset.tab = trigger.dataset.tab;
        tabButton.textContent = trigger.textContent.trim();
        tabsHeader.appendChild(tabButton);
      });

      // Insert the tabs header at the beginning
      this.insertBefore(tabsHeader, this.firstChild);

      // Add event listeners to the new header buttons
      tabsHeader.querySelectorAll(".tabs-menu-trigger").forEach((trigger) => {
        trigger.addEventListener("click", this.onTabClick.bind(this));
      });
    }
  }

  onTabClick(event) {
    event.preventDefault();

    // Remove active class from all triggers (both original and header)
    this.querySelectorAll(".action-tab-trigger, .tabs-menu-trigger").forEach(
      (trigger) => {
        trigger.classList.remove("active");
      }
    );

    // Add active class to clicked trigger
    event.target.classList.add("active");

    // Also activate the corresponding original trigger if this was a header click
    if (event.target.classList.contains("tabs-menu-trigger")) {
      const originalTrigger = this.querySelector(
        `.action-tab-trigger[data-tab="${event.target.dataset.tab}"]`
      );
      if (originalTrigger) {
        originalTrigger.classList.add("active");
      }
    } else {
      // If this was an original trigger click, also activate the header button
      const headerTrigger = this.querySelector(
        `.tabs-menu-trigger[data-tab="${event.target.dataset.tab}"]`
      );
      if (headerTrigger) {
        headerTrigger.classList.add("active");
      }
    }

    // Hide all tab contents
    this.querySelectorAll(".tab-content").forEach((content) => {
      content.classList.remove("active");
    });

    // Show the selected tab content
    const selectedContent = this.querySelector(
      `.tab-content[data-tab="${event.target.dataset.tab}"]`
    );
    if (selectedContent) {
      selectedContent.classList.add("active");
    }
  }
}

customElements.define("tabs-menu", TabsMenu);
class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    this.closeOnlyDrawer = this.hasAttribute("data-close-drawer");
    this.header = document.getElementById("shopify-section-new-header");
    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );

    // TODO: This should not be part of a global primitive used also in other things than mobile facets :(
    this.querySelectorAll(".mobile-facets__close").forEach((el) =>
      el.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.pageScrollLock) {
          this.closeMenuDrawer(
            e,
            this.mainDetailsToggle.querySelector("summary")
          );
        } else {
          this.onCloseButtonClick(e);
        }
      })
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
        event,
        this.mainDetailsToggle.querySelector("summary")
      )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    // fix drawer invisible issue
    document.querySelector(".PageOverlay")?.classList.add("is-visible");
    this.removeStickyHeaderListner();
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
            "transitionend",
            addTrapFocus
          );
      }, 100);
    }
  }

  removeStickyHeaderListner() {
    this.stickyHeader =
      this.stickyHeader || document.querySelector("sticky-header");
    if (this.stickyHeader) {
      window.removeEventListener(
        "scroll",
        this.stickyHeader.onScrollHandler,
        false
      );
      setTimeout(() => {
        window.addEventListener(
          "scroll",
          this.stickyHeader.onScrollHandler,
          false
        );
      }, 150);
    }
  }

  openMenuDrawer(summaryElement) {
    let headerSection = document.getElementById("shopify-section-new-header");
    if (headerSection && !headerSection.classList.contains("z-index")) {
      headerSection.classList.add("z-index");
    }
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    this.lockPageScroll();
    document.documentElement.classList.add(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    document.querySelector(".PageOverlay")?.classList.add("is-visible");
    this.removeStickyHeaderListner();
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      document.querySelector(".PageOverlay")?.classList.remove("is-visible");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        if (!this.closeOnlyDrawer) {
          details.removeAttribute("open");
        }
        details.classList.remove("menu-opening");
        this.header.classList.remove("menu-drawer-open");
      });
      document.documentElement.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      this.restorePageScroll();
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
      // annoucement bar overlap cart issue
      let headerSection = document.getElementById("shopify-section-new-header");
      if (headerSection && headerSection.classList.contains("z-index")) {
        headerSection.classList.remove("z-index");
      }
    }
  }

  lockPageScroll() {
    if (this.dataset.breakpoint !== "all-screens" || this.pageScrollLock) return;

    const body = document.body;
    this.pageScrollLock = {
      scrollY: window.scrollY,
      position: body.style.position,
      top: body.style.top,
      left: body.style.left,
      right: body.style.right,
      width: body.style.width,
    };

    body.style.position = "fixed";
    body.style.top = `-${this.pageScrollLock.scrollY}px`;
    body.style.left = "0";
    body.style.right = "0";
    body.style.width = "100%";
  }

  restorePageScroll() {
    if (!this.pageScrollLock) return;

    const body = document.body;
    const root = document.documentElement;
    const lock = this.pageScrollLock;
    const scrollBehavior = root.style.scrollBehavior;

    body.style.position = lock.position;
    body.style.top = lock.top;
    body.style.left = lock.left;
    body.style.right = lock.right;
    body.style.width = lock.width;
    root.style.scrollBehavior = "auto";
    window.scrollTo(0, lock.scrollY);
    root.style.scrollBehavior = scrollBehavior;
    this.pageScrollLock = null;
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    if (
      event.target.classList &&
      !event.target.classList.contains("localization-form__select")
    ) {
      const detailsElement = event.currentTarget.closest("details");
      this.closeSubmenu(detailsElement);
    }
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 10) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.querySelector("button.action-close")?.addEventListener(
      "click",
      this.closeMenuDrawer.bind(this)
    );

    //  <details-modal class="header__search ">
    const searchDetails = document.querySelector("details-modal.header__search details");
    this.querySelector("button.action-search-trigger")?.addEventListener(
      "click",
      (event) => {
        event.preventDefault();
        if (!searchDetails) return;
        searchDetails.open = true;
        searchDetails.querySelector("input")?.focus();
      }
    )
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.slider.querySelectorAll(':scope > [id^="Slide-"]');
    this.enableSliderLooping = false;
    this.sliderButtons = this.querySelector(":scope > .slider-buttons");
    if (this.sliderButtons) {
      this.currentPageElement = this.sliderButtons.querySelector(
        ".slider-counter--current"
      );
      this.pageTotalElement = this.sliderButtons.querySelector(
        ".slider-counter--total"
      );
      this.prevButton =
        this.sliderButtons.querySelector('button[name="previous"]') ||
        this.querySelector(":scope > ");
      this.nextButton =
        this.sliderButtons.querySelector('button[name="next"]') ||
        this.querySelector(":scope > ");
    } else {
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
    }

    if (!this.slider || !this.sliderButtons & !this.prevButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    this.sliderLastItem =
      this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.slider.querySelectorAll(':scope [id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderLastItem.clientWidth
        : this.slider.scrollLeft - step * this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(":scope > .slider-buttons");
    this.enableSliderLooping = false;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(
      ":scope > .slideshow__slide"
    );
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.sliderControlWrapper.querySelector(
      ":scope .slideshow__autoplay"
    );
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderButtons = this.querySelector(":scope > .slider-buttons");
    this.sliderControlButtons = this.sliderButtons.querySelectorAll(
      ":scope .slider-counter__link"
    );
    // this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    try {
      this.sliderControlButtons[this.currentPage - 1].classList.add(
        "slider-counter__link--active"
      );
      this.sliderControlButtons[this.currentPage - 1].setAttribute(
        "aria-current",
        true
      );
    } catch (e) {
    }
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
        this.slider.querySelector(":scope > .slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a");
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (button) button.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) +
        1 -
        this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);

    if (!this.currentVariant) {
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      // Sync product forms before optional product UI updates run.
      this.updateVariantInput();
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateDeliveryTime();
      this.updateMedia();
      this.updateURL();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`
    );
    mediaGallery.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
      false
    );
  }

  updateDeliveryTime() {
    const allDeliveryTimes = document.querySelectorAll(".delivery-time");
    allDeliveryTimes.forEach((delivery) => {
      if (
        this.currentVariant.id ==
        Number(delivery.getAttribute("delivery-time-id"))
      ) {
        delivery.style.display = "block";
      } else {
        delivery.style.display = "none";
      }
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (
      this.currentVariant &&
      this.currentVariant.available &&
      typeof pickUpAvailability.fetchAvailability === "function"
    ) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (
      productForm &&
      typeof productForm.handleErrorMessage === "function"
    ) {
      productForm.handleErrorMessage();
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");
        if (
          !document
            .querySelector(".product-form__checkout-btn--wrap button")
            .hasAttribute("data-prelaunch-text")
        )
          this.toggleAddButton(
            !this.currentVariant.available,
            window.variantStrings.soldOut
          );
      })
      .catch((e) => {
        console.error(e);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;


    // existing button logic
    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
      if (addButton.dataset.prelaunchText != null)
        addButtonText.textContent = addButton.dataset.prelaunchText;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
  updateMedia() {
    // noting
  }
}

customElements.define("variant-radios", VariantRadios);

// js/common/ui/marquee-text.js
var MarqueeText = class extends HTMLElement {
  constructor() {
    super();
    if (window.ResizeObserver) {
      new ResizeObserver(this._calculateDuration.bind(this)).observe(this);
    }
  }
  _calculateDuration(entries) {
    const scrollingSpeed = parseInt(this.getAttribute("scrolling-speed") || 5),
      contentWidth = entries[0].contentRect.width,
      slowFactor = 1 + (Math.min(1600, contentWidth) - 375) / (1600 - 375);
    this.style.setProperty(
      "--marquee-animation-duration",
      `${(
        (scrollingSpeed *
          slowFactor *
          entries[0].target.querySelector("span").clientWidth) /
        contentWidth
      ).toFixed(3)}s`
    );
  }
};
if (!window.customElements.get("marquee-text")) {
  window.customElements.define("marquee-text", MarqueeText);
}

// class QuickViewTrigger extends HTMLElement {
//   constructor() {
//     super();
//   }
//   connectedCallback() {
//     this.addEventListener("click", () => {
//       this.dispatchEvent(
//         new CustomEvent("open-quick-view", {
//           detail: { productUrl: this.dataset.productUrl },
//           bubbles: true,
//           composed: true,
//         })
//       );
//     });
//   }
// }
// customElements.define("quick-view-trigger", QuickViewTrigger);

// class QuickViewDrawer extends HTMLElement {
//   constructor() {
//     super();
//     this.querySelector("button.action-close-quick-view").addEventListener(
//       "click",
//       this.closeQuickViewDrawer.bind(this)
//     );
//     this.querySelector(".quick-view-drawer__backdrop").addEventListener(
//       "click",
//       this.closeQuickViewDrawer.bind(this)
//     );

//   }
//   connectedCallback() {
//     window.addEventListener("open-quick-view", (event) => {
//       if (event.detail.productUrl) {
//         this.openQuickViewDrawer(event.detail.productUrl);
//       }
//     });
//   }
//   openQuickViewDrawer(productUrl) {
//     const globalThis = this;
//     fetch(`${productUrl}?view=quick-view`)
//       .then((response) => response.text())
//       .then((html) => {
//         const contentDiv = this.querySelector(".quick-view-drawer__content");
//         if (!contentDiv) console.log("contentDiv not found", this);
//         contentDiv.innerHTML = html;
//         this.classList.add("open");
//         this.classList.remove("loading");
//         document.documentElement.classList.add(`overflow-hidden-all-screens`);
//         const productFormId =
//           contentDiv.querySelector("product-form").dataset.productFormId;
//         const variantRadios = contentDiv.querySelectorAll(
//           "fieldset .pqv__variant-options label"
//         );
//         const relatedProducts = contentDiv.querySelectorAll(
//           ".pqv__related-product"
//         );
//         console.log("VARIANT RADIOS", variantRadios);
//         if (variantRadios) {
//           variantRadios.forEach(function (label) {
//             if (label.classList.contains("soldout")) return;
//             label.addEventListener("click", function (event) {
//               const hiddenInput = document.querySelector(
//                 `#${productFormId} input[name="id"]`
//               );
//               console.log(
//                 "HIDDEN INPUT",
//                 `#${productFormId} input[name="id"]`,
//                 hiddenInput
//               );
//               hiddenInput.value = event.currentTarget.dataset.variantId;
//               // input should also be checked
//               const variantInput = contentDiv.querySelector(
//                 `input[form="${productFormId}"][data-variant-id="${event.currentTarget.dataset.variantId}"]`
//               );
//               console.log("VARIANT INPUT", variantInput);
//               variantInput.checked = true;
//             });
//           });
//         }
//         if (relatedProducts) {
//           relatedProducts.forEach(function (product) {
//             product.addEventListener("click", function (event) {
//               globalThis.classList.add("loading");
//               event.preventDefault();
//               const productUrl = product.dataset.variantLink;
//               console.log("PRODUCT URL", productUrl);
//               globalThis.openQuickViewDrawer(productUrl);
//             });
//           });
//         }
//       })
//       .catch((error) => {
//         console.error("Error loading product or metafields:", error);
//       });
//   }
//   closeQuickViewDrawer() {
//     this.classList.remove("open");
//     document.documentElement.classList.remove(`overflow-hidden-all-screens`);
//     document.documentElement.classList.remove(`overflow-hidden`);
//     document.body.classList.remove(`overflow-hidden`);
//   }

// }
// customElements.define("quick-view-drawer", QuickViewDrawer);

class CartDrawer extends MenuDrawer {
  constructor() {
    super();

    this.bindOnMenuDrawerOpen();
    //hide gamification in other countries than germany
    // this.gamificationBasedOnCountry();
  }

  connectedCallback() {
    window.addEventListener("load", (event) => {
      document.querySelector("cart-drawer").OnMenuDrawerOpen();
    });
  }

  bindOnMenuDrawerOpen() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", () => {
        if (this.querySelector("#drawer-cart-items").childElementCount == 0) {
          this.OnMenuDrawerOpen.bind(this);
        }
      })
    );
  }

  // gamificationBasedOnCountry(){
  //   let location_url = window.location.href;
  //   if(location_url.includes('uk.')
  //   || location_url.includes('eu.')
  //   || location_url.includes('ch.') || (localStorage.getItem('userCountryCode')
  //   && localStorage.getItem('userCountryCode') != 'DE')){
  //     let gamificationWrapper = this.querySelector('#cart-drawer-gamification'),
  //         tempThis = this;

  //       gamificationWrapper.style.display = 'none';

  //     this.changeDrawerHeightsBasedOnGamification();
  //     window.addEventListener('resize', function(){
  //       tempThis.changeDrawerHeightsBasedOnGamification();
  //     });
  //   }
  // }

  changeDrawerHeightsBasedOnGamification() {
    let headerWrapper = this.querySelector(".cart-drawer__header"),
      navigationWrapper = this.querySelector(".cart-drawer__navigation");

    headerWrapper.style.height = "64px";
    headerWrapper.style.borderBottom = "1px solid #e0e0e0";
    navigationWrapper.style.height = "calc(100vh - 64px)";
    navigationWrapper.style.maxHeight = "calc(100% - 64px)";

    if (window.innerWidth <= 750) {
      headerWrapper.style.height = "54px";
      navigationWrapper.style.height = "calc(100vh - 54px)";
      navigationWrapper.style.maxHeight = "calc(100% - 54px)";
    }
  }

  OnMenuDrawerOpen() {
    const locale =
      window.Shopify && window.Shopify.locale ? window.Shopify.locale : "en";

    const sectionIds = this.getSectionsToRender()
      .map((section) => section.id)
      .join(",");

    const sectionsURL = `${window.Shopify.routes.root}?sections=${sectionIds}`;

    fetch(sectionsURL, {
      headers: {
        "Accept-Language": locale,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }

        const sections = { sections: response };
        this.renderContents(sections);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  renderContents(parsedState, forceDrawerOpen = false) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    crossSellITemsListeners();
    this.handleCrossSellGrapping();
    // if (this.header) this.header.reveal();
    // this.open();
    const drawerDetails = this.querySelector("details");
    if (forceDrawerOpen && drawerDetails && !drawerDetails.hasAttribute("open")) {
      this.querySelector("summary").click();
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "drawer-cart-items",
      },
      {
        id: "drawer-cart-footer",
      },
      {
        id: "cart-icon-bubble",
      },
      {
        id: "cart-drawer-gamification",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  handleCrossSellGrapping() {
    const crossSellSlider = document.querySelector(".cross-sell-slider");
    let isDown = false;
    let startX;
    let scrollLeft;

    if (crossSellSlider) {
      crossSellSlider.addEventListener("mousedown", (e) => {
        isDown = true;
        crossSellSlider.classList.add("active");
        startX = e.pageX - crossSellSlider.offsetLeft;
        scrollLeft = crossSellSlider.scrollLeft;
      });
      crossSellSlider.addEventListener("mouseup", () => {
        isDown = false;
        crossSellSlider.classList.remove("active");
      });
      crossSellSlider.addEventListener("mouseleave", () => {
        isDown = false;
        crossSellSlider.classList.remove("active");
      });
      crossSellSlider.addEventListener("mousemove", (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - crossSellSlider.offsetLeft;
        const walk = x - startX;
        crossSellSlider.scrollLeft = scrollLeft - walk;
      });
    }
  }
}

customElements.define("cart-drawer", CartDrawer);

// quick add to cart
let quickAddToCart = (function () {
  function addProductToCart(
    line,
    quantity,
    cartModal,
    parent,
    forceDrawerOpen = true,
    giftProduct = false
  ) {
    cartModal?.setActiveElement(document.activeElement);
    let item = {
      id: line,
      quantity: quantity,
      properties: {},
    };
    if (giftProduct) {
      item["properties"]["_gift"] = true;
    }
    const items = {
      items: [item],
      sections:
        "drawer-cart-items,drawer-cart-footer,cart-icon-bubble,cart-drawer-gamification",
      sections_url: window.location.pathname,
    };

    const body = JSON.stringify(items);

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        // if (response.status != 200) return response;

        if (!response.ok) {
          if (parent && parent.errorMessageWrapper) {

            parent.errorMessageWrapper =
              parent.errorMessageWrapper ||
              parent.querySelector(".product-form__error-message-wrapper");
            parent.errorMessage =
              parent.errorMessage ||
              parent.errorMessageWrapper.querySelector(
                ".product-form__error-message"
              );

            parent.errorMessageWrapper.toggleAttribute(
              "hidden",
              !response.description
            );

            if (response.description) {
              parent.errorMessage.textContent = parent.errorMessage;
            }
          }
        }
        return response.json();
      })
      .then((response) => {
        if (response && response.errors) {
          if (window.showToast) {
            window.showToast(response.errors, 5000);
          }
          return;
        }
        // if (response.status) {
        //   if (parent && parent.errorMessageWrapper) {
        //     parent.errorMessageWrapper =
        //       parent.errorMessageWrapper ||
        //       parent.querySelector(".product-form__error-message-wrapper");
        //     parent.errorMessage =
        //       parent.errorMessage ||
        //       parent.errorMessageWrapper.querySelector(
        //         ".product-form__error-message"
        //       );

        //     parent.errorMessageWrapper.toggleAttribute(
        //       "hidden",
        //       !response.description
        //     );

        //     if (response.description) {
        //       parent.errorMessage.textContent = errorMessage;
        //     }
        //   }
        //   return;
        // }
        window.dispatchEvent(new CustomEvent("dresslife:cart-change", {
          detail: {
            source: "quick-add",
            cart: response,
          },
        }));
        if (cartModal) cartModal.renderContents(response, forceDrawerOpen);
      })
      .catch((e) => {
        console.error(e);
      });
  }
  function setListeners(selector) {
    let productsContainer = document.querySelector(selector);
    let cartModal = document.querySelector("cart-drawer");

    if (productsContainer) {
      productsContainer.addEventListener("click", function (e) {
        if (e.target.className.includes) {
          if (e.target.className.includes("sizes__wrapper--item")) {
            addProductToCart(
              e.target.dataset.variant,
              1,
              cartModal,
              e.target.parentNode.parentNode
            );
            if (e.target.dataset.productHandle) {
              updateWishlist(
                e.target.dataset.productHandle,
                e.target.dataset.productPrice
              );
            }
          } else if (e.target.className.includes("close-sizes__wrapper")) {
            document.querySelector(
              `.sizes__wrapper[data-product-id="${e.target.dataset.productId}"]`
            ).style.display = "none";
            document
              .querySelector
              // `.show-product__sizes[data-product-id="${e.target.dataset.productId}"]`
              ().style.display = "block";
          } else if (e.target.className.includes("show-product__sizes")) {
            // e.target.style.display = "none";
            // document.querySelector(
            //   `.sizes__wrapper[data-product-id="${e.target.dataset.productId}"]`
            // ).style.display = "block";
          }
        }
      });
    }
  }
  return {
    setSizeListners: setListeners,
    addToCart: addProductToCart,
  };
})();

// cross sell
const crossSellITemsListeners = () => {
  let add_x_sell_cart_items = document.querySelectorAll(".add_x_sell_cart, .action-cart-carousel-atc"),
    cartModal = document.querySelector("cart-drawer");

  if (add_x_sell_cart_items && add_x_sell_cart_items.length > 0) {
    for (var i = 0, l = add_x_sell_cart_items.length; i < l; i++) {
      add_x_sell_cart_items[i].addEventListener("click", function () {
        let variantId = this.getAttribute("data-variant-id");
        let giftProduct = this.getAttribute("data-gift-product") || false;
        quickAddToCart.addToCart(
          variantId,
          1,
          cartModal,
          "",
          false,
          giftProduct
        );
      });
    }
  }
};

document.addEventListener("DOMContentLoaded", function () {
  crossSellITemsListeners();
});

// format money
themeObj.utils = {
  defaultTo: function (value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  },
};
themeObj.Currency = (function () {
  var moneyFormat = "${{amount}}";

  function formatMoney(cents, format) {
    if (!format) {
      format = themeObj.settings.moneyFormat;
    }

    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = themeObj.utils.defaultTo(precision, 2);
      thousands = themeObj.utils.defaultTo(thousands, ",");
      decimal = themeObj.utils.defaultTo(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }
  return {
    formatMoney: formatMoney,
  };
})();

// utility functions
const fetchProductCardHTML = (
  handle,
  classNames = "grid__item",
  isFullUrl = false
) => {
  const productTileTemplateUrl = isFullUrl
    ? handle + "?view=card"
    : `/products/${handle}?view=card`;

  return fetch(productTileTemplateUrl)
    .then((res) => res.text())
    .then((res) => {
      const text = res;
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(text, "text/html");
      const productCardWrapper = document.createElement("div");
      productCardWrapper.className = classNames;
      const productCard =
        htmlDocument.documentElement.querySelector(".card-wrapper");
      productCardWrapper.appendChild(productCard);
      return productCardWrapper.outerHTML;
    })
    .catch((err) =>
      console.error(
        `[Fetch product card client side by handle] Failed to load content for handle: ${handle}`,
        err
      )
    );
};

const fetchProductCardHTMLByFirstVariant = (
  variantId,
  classNames = "grid__item"
) => {
  // Watch out, window.routes.root_url in main market is /, so including it breaks the url (in other markets it is a subdirectory that can be prepended safely)

  const productTileTemplateUrl = `${window.routes.root_url !== "/" ? window.routes.root_url : ""}/variants/${variantId}`;

  return fetch(productTileTemplateUrl)
    .then((res) => res.text())
    .then((res) => {
      const text = res;
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(text, "text/html");
      const canonicalUrl = htmlDocument.querySelector(
        "link[rel='canonical']"
      ).href;
      return fetchProductCardHTML(canonicalUrl, classNames, true);
    })
    .catch((err) =>
      console.error(
        `[Fetch Product Ids By first Variant] Failed to load content for variant ID: ${variantId}`,
        err
      )
    );
};

document.addEventListener("DOMContentLoaded", function () {
  let maxRetries = 60; // Retry for 60 seconds
  let intervalTime = 1000; // Check every second
  let retryCount = 0;
  let interval = setInterval(() => {
    let wishlistGrid = document.querySelector(".swym-wishlist-grid");

    if (wishlistGrid) {
      let items = document.querySelectorAll(".swym-wishlist-grid > li");

      if (items.length > 0) {
        clearInterval(interval);
        processWishlist();
        const loginButton = document.getElementById(
          "swym-user-login-status-btn"
        );
        const wishlistHeader = document.querySelector(
          ".swym-wishlist-detail-header"
        );

        if (loginButton && wishlistHeader) {
          wishlistHeader.appendChild(loginButton); // Moves the button inside the header
        }
      }
    }

    retryCount++;
    if (retryCount >= maxRetries) {
      clearInterval(interval);
      console.warn("Wishlist grid not found after 1 minute.");
    }
  }, intervalTime);
});

function normalizeText(text) {
  if (!text || typeof text !== "string") return ""; // Ensure text is valid

  return text
    .toLowerCase()
    .replace(/[\u2018\u2019\u201C\u201D]/g, "'") // Convert curly quotes to normal ones
    .replace(/['"\-,]/g, "") // Remove apostrophes, quotes, commas, hyphens
    .trim();
}

let WishListData;
let WishListDataProduct = localStorage.getItem("swym-products");
try {
  WishListData = WishListDataProduct ? JSON.parse(WishListDataProduct) : null;
} catch (error) {
  WishListData = null;
}
const wishlistBubble = document.querySelector(".wishlistbuble");
const wishlistCount = Array.isArray(WishListData?.all) ? WishListData.all.length : 0;

if (wishlistBubble && wishlistCount > 0) {
  wishlistBubble.querySelectorAll("span").forEach((span) => {
    span.textContent = wishlistCount;
  });
  wishlistBubble.style.display = "block"; // Show the bubble
}

function processWishlist() {
  let storedProducts = localStorage.getItem("swym-products");

  if (!storedProducts) {
    console.warn("No swym-products found in localStorage.");
    return;
  }

  let productData;
  try {
    productData = JSON.parse(storedProducts);
  } catch (error) {
    console.error("Error parsing swym-products:", error);
    return;
  }

  if (!Array.isArray(productData?.all)) return;

  document.querySelectorAll(".swym-wishlist-grid > li").forEach((item) => {
    if (item.querySelector("a")) return; // Prevent duplicate wrapping

    let span = item.querySelector("span[id]");
    if (!span) return;

    let rawTitle = span.textContent.trim();
    let normalizedTitle = normalizeText(rawTitle);

    const Wishdata = { productData };

    let matchedProduct = Wishdata.productData.all.find(
      (product) => normalizeText(product.dt) === normalizedTitle
    );

    if (!matchedProduct) {
      console.warn("No matching product found for:", rawTitle);
      return;
    }

    let productId = matchedProduct.empi;
    let variantId = matchedProduct.epi;

    // Create and show loading overlay
    let loadingOverlay = document.createElement("div");
    loadingOverlay.className = "wishlist-loading-overlay";
    loadingOverlay.textContent = "Loading...";
    item.appendChild(loadingOverlay);

    async function getAllProducts() {
      let allProducts = [];
      let page = 1;
      let hasMoreProducts = true;

      try {
        while (hasMoreProducts) {
          const marketPrefix = window.Shopify?.routes?.root || "/";

          const response = await fetch(
            `${marketPrefix}products.json?limit=250&page=${page}`
          );
          const data = await response.json();

          if (data.products.length > 0) {
            allProducts = [...allProducts, ...data.products];
            page++;
          } else {
            hasMoreProducts = false;
          }
        }
        return allProducts;
      } catch (error) {
        console.error("Error fetching all products:", error);
        return [];
      }
    }

    async function getProductUrlByVariant(variantId) {
      try {
        const products = await getAllProducts();

        for (let product of products) {
          for (let variant of product.variants) {
            if (variant.id == variantId) {
              return markethandle === "/"
                ? `/products/${product.handle}?variant=${variantId}`
                : `${markethandle}/products/${product.handle}?variant=${variantId}`;
            }
          }
        }

        console.warn("Variant not found:", variantId);
        return null;
      } catch (error) {
        console.error("Error fetching product URL:", error);
        return null;
      }
    }

    getProductUrlByVariant(variantId).then((productUrl) => {
      if (!productUrl) {
        if (loadingOverlay) loadingOverlay.remove();
        return;
      }

      let anchor = document.createElement("a");
      anchor.href = productUrl;
      anchor.setAttribute("data-id", productId);
      anchor.setAttribute("data-variantID", variantId);
      anchor.style.textDecoration = "none";
      anchor.style.color = "inherit";

      // Replace the title text inside the item with the official product title
      // We'll fetch the product title from the "products" data retrieved inside getAllProducts
      // So first, find the product matching variantId from that cached data:

      getAllProducts().then((allProducts) => {
        let foundProduct = null;
        for (let product of allProducts) {
          if (product.variants.some((v) => v.id == variantId)) {
            foundProduct = product;
            break;
          }
        }

        if (foundProduct) {
          // Find existing title element inside the item (or create one)
          let existingTitle = item.querySelector("h2.swym-title");
          if (existingTitle) {
            existingTitle.textContent = foundProduct.title; // Replace text with official title
          } else {
            let newTitle = document.createElement("h2");
            newTitle.className = "swym-title swym-title-1";
            newTitle.textContent = foundProduct.title;
            item.insertBefore(newTitle, item.firstChild);
          }
        }

        // Now wrap the whole content inside the anchor
        while (item.firstChild) {
          anchor.appendChild(item.firstChild);
        }

        item.appendChild(anchor);
        if (loadingOverlay) loadingOverlay.remove();
      });
    });
  });
}

// CSS to style the loading overlay
const style = document.createElement("style");
style.textContent = `
  .wishlist-loading-overlay {
    position: absolute;
    top: 0;
    padding-top: 30px;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: flex-start;
    justify-content: center;
    font-size: 14px;
    font-weight: bold;
    z-index: 10;
  }
`;
document.head.appendChild(style);


const COLLECTION_SCROLL_STORAGE_KEY = "collection-scroll-position:";

function isCollectionScrollPage() {
  return (
    window.location.pathname.includes("/collections/") ||
    window.location.pathname.includes("/search")
  );
}

function getCollectionScrollStorageKey() {
  return `${COLLECTION_SCROLL_STORAGE_KEY}${window.location.pathname}${window.location.search}`;
}

function saveCollectionScrollPosition() {
  if (!isCollectionScrollPage()) return;

  sessionStorage.setItem(
    getCollectionScrollStorageKey(),
    String(window.scrollY || window.pageYOffset || 0)
  );
}

function isBackForwardNavigation(event) {
  if (event.persisted) return true;

  const navigationEntries =
    typeof window.performance?.getEntriesByType === "function"
      ? window.performance.getEntriesByType("navigation")
      : [];

  if (navigationEntries.length > 0) {
    return navigationEntries[0].type === "back_forward";
  }

  return window.performance?.navigation?.type === 2;
}

function restoreCollectionScrollPosition(event) {
  if (!isCollectionScrollPage() || !isBackForwardNavigation(event)) return;

  const scrollPosition = sessionStorage.getItem(getCollectionScrollStorageKey());
  const targetY = parseInt(scrollPosition || "", 10);

  if (Number.isNaN(targetY)) return;

  const applyScrollPosition = () => {
    window.scrollTo(0, targetY);
    sessionStorage.removeItem(getCollectionScrollStorageKey());
  };

  window.requestAnimationFrame(applyScrollPosition);

  if (document.readyState !== "complete") {
    window.addEventListener("load", applyScrollPosition, { once: true });
  }
}

document.addEventListener(
  "click",
  (event) => {
    if (!isCollectionScrollPage()) return;
    if (!(event.target instanceof Element)) return;

    const clickedLink = event.target.closest("a[href]");
    if (!clickedLink) return;

    const targetUrl = new URL(clickedLink.href, window.location.origin);
    if (
      targetUrl.origin === window.location.origin &&
      targetUrl.pathname.includes("/products/")
    ) {
      saveCollectionScrollPosition();
    }
  },
  true
);

document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "hidden") {
    saveCollectionScrollPosition();
  }
});

window.addEventListener("pagehide", saveCollectionScrollPosition);
window.addEventListener("pageshow", restoreCollectionScrollPosition);

(() => {
  if (window.__teveoStickyMobileAtcInitialized) return;
  window.__teveoStickyMobileAtcInitialized = true;

  const updateOffset = (isFixed) => {
    const visualViewport = window.visualViewport;
    const bottomOffset = isFixed && visualViewport
      ? Math.max(0, window.innerHeight - visualViewport.height - visualViewport.offsetTop)
      : 0;

    document.documentElement.style.setProperty(
      "--sticky-atc-bottom",
      `${Math.round(bottomOffset)}px`
    );
  };

  const update = () => {
    const wrapper = document.getElementById("add-to-cart__wrapper");
    const buttons = wrapper?.querySelector(".product-form__buttons");

    if (!buttons) {
      updateOffset(false);
      return;
    }

    if (window.innerWidth > 749) {
      buttons.classList.remove("product-form__buttons--fixed-mobile");
      updateOffset(false);
      return;
    }

    const isFixed = wrapper.getBoundingClientRect().bottom <= 0;
    buttons.classList.toggle("product-form__buttons--fixed-mobile", isFixed);
    updateOffset(isFixed);
  };

  let updateTimer = null;
  const scheduleUpdate = () => {
    if (updateTimer !== null) return;
    updateTimer = window.setTimeout(() => {
      updateTimer = null;
      update();
    }, 0);
  };

  window.addEventListener("scroll", scheduleUpdate, { passive: true });
  window.addEventListener("resize", scheduleUpdate);
  window.addEventListener("pageshow", scheduleUpdate);
  document.addEventListener("shopify:section:load", scheduleUpdate);

  if (window.visualViewport) {
    window.visualViewport.addEventListener("scroll", scheduleUpdate, { passive: true });
    window.visualViewport.addEventListener("resize", scheduleUpdate);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleUpdate, { once: true });
  } else {
    scheduleUpdate();
  }
})();
